import * as React from 'react';
import { inject, deps, observer, ComponentProps } from '../lib/component';
import { PlayButtonCompat } from '../components/compat/play-button-compat';
import { AddRemoveCompat } from '../components/compat/add-remove-compat';
import { FavouriteButtonCompat } from '../components/compat/favourite-button-compat';
import {AppJustAdded} from '../components/app-just-added';
import {ArtistSchema, TrackSchema} from '../types/schema';

export interface JustAddedProps extends ComponentProps {

}

export interface JustAddedState {
  tracks: Array<TrackSchema>;
}

@inject(deps) @observer
export class JustAdded extends React.Component<JustAddedProps, JustAddedState> {
  private $el: any;
  private _mounted: boolean = false;

  render() {
    if (!this.props.model.ui.showJustAdded) return null;
    const {handleClickLink} = this.props.controller.ui;

    return (
      <AppJustAdded
        ref={el => this.$el = el}
        PlayButton={PlayButtonCompat}
        AddRemove={AddRemoveCompat}
        Favourite={FavouriteButtonCompat}
        onClickLink={handleClickLink}
        tracks={this.state.tracks}
        preload={this.props.controller.image.preloadImage}
        analytics={this.props.controller.analytics}
      />
    )
  }

  constructor(props: JustAddedProps) {
    super(props);
    this.state = { tracks: [] };
  }

  async componentDidMount() {
    this._mounted = true;
    const response = await this.props.controller.api.browse.getRecentlyAddedTracks();
    this._mounted && this.$el && this.setState({ tracks: response.data });
  }

  componentWillUnmount() {
    this._mounted = false;
  }
}